import { render, staticRenderFns } from "./TopbarSitecore.vue?vue&type=template&id=613da398"
import script from "./TopbarSitecore.vue?vue&type=script&lang=js"
export * from "./TopbarSitecore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports